
import { Component, AfterContentInit, OnDestroy, ElementRef } from '@angular/core';
import { PlycaDataService } from '../../../services/plyca.service';
import { UIService } from '../../ui.service';
import { TranslateService } from '@ngx-translate/core';
import { LogDTO } from '../../api/plyca-dtos-v2';
import { PaginationDTO } from '../../api/PaginationModel';
import { HelpService, HelpType } from '../../components/common/help/help.service';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { BaseComponent } from '../../components/common/baseComponent/base.component';

@Component({
  selector: 'logsPanel',
  templateUrl: 'logsPanel.template.html'
})
export class logsPanelComponent extends BaseComponent
  implements AfterContentInit, OnDestroy {
  loaded = false;
  logs: LogDTO[] = [];
  constructor(
    public plycaService: PlycaDataService,
    public helpService: HelpService,
    public uiService: UIService,
    private headerActionsService: HeaderActionsService,
    private elem: ElementRef
  ) {
    super();
    this.subscribe(this.helpService.showContextHelpObservable(HelpType.LOGS));

  }

  ngAfterContentInit(): void {

    this.headerActionsService.setTaskDescription(this.elem, 'Logs.title', 'fab fa-readme', this.isLoaded.bind(this));
    this.subscribe(
      this.headerActionsService.addAction(
        'General.reload',
        'fas fa-sync-alt',
        'btn-secondary',
        true
      ), success => {
        this.loadLogs();
      });
    this.headerActionsService.addDivider();
    this.subscribe(
      this.headerActionsService.addAction(
        'General.back',
        'fas fa-chevron-left',
        'btn-outline-secondary',
        true
      ), success => {
        this.uiService.routeBack();
      });

    this.loadLogs();
  }

  ngOnDestroy() {
    this.headerActionsService.clearActions();
    super.ngOnDestroy();
  }

  public isLoaded(): boolean {
    return this.loaded;
  }

  loadLogs() {
    this.loaded = false;
    this.subscribe(this.plycaService.getLogs(), (result: PaginationDTO<LogDTO>) => {
      if (result && result.content) {
        this.logs = result.content;
      }
      this.loaded = true;
    });
  }

  download(log: LogDTO) {
    this.subscribe(this.plycaService.getLogFile(log));
  }

}
